module.exports = __webpack_public_path__ + "./docs/img/icon-object.166afeab8b760786fd6d831f54c8d280.svg";